import { useQuery } from "@tanstack/react-query";
import { WorkflowIntegration } from "../types/integrations";
import { toast } from "react-toastify";
import customFetch from '../utils/customFetch';


export const useGetAddedIntegrations = () => {
    return useQuery<WorkflowIntegration[], ErrorEvent>({
      queryKey: ['addedIntegrations'],
      queryFn: () => {
        return customFetch(`/v1/integrations`)
          .then(async(res) => {
            const data = await res.json();
            return res.ok
              ? data
              : Promise.reject(new Error('Failed to get integrations'))
          })
          .catch((err) => toast.error(err.message));
      }
    });
  }